import type React from 'react'
import type { IconProps } from '@/types'

export const EnvelopeIcon: React.FC<IconProps> = ({ className = 'h-5 w-5', size }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      height={size}
      width={size}
    >
      <title>Envelope</title>
      <path
        d="m1.5 4.75 21 0 0 15 -21 0Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="m22.161 5.3 -8.144 6.264a3.308 3.308 0 0 1 -4.034 0L1.839 5.3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}
